module.exports = __webpack_public_path__ + "media/images/vendors/missing_vendors-56934793e3c080e2e3046d603449b79d.png";